import React from 'react';
import { useTranslation } from 'react-i18next';
import { OrgUserEntry } from '../../types';

/**
 * Number of role grants for a user: unique (domain, role) pairs plus
 * org-level roles.
 */
export function countUserRoleAssignments(user: OrgUserEntry): number {
  const siteCells = new Set<string>();
  let orgRoles = 0;
  for (const a of user.assignments) {
    if (a.is_org_role) orgRoles += 1;
    else if (a.site_id) siteCells.add(`${a.site_id}::${a.role_id}`);
  }
  return siteCells.size + orgRoles;
}

/**
 * Optional "Roles" column cell (hidden by default) shared by Security > Users
 * and the Command Center org admins list.
 */
export const UserRolesCell: React.FC<{ user: OrgUserEntry }> = ({ user }) => {
  const { t } = useTranslation();
  if (user.assignments.length === 0) {
    return <span className="manage-users-audit-cell">{t('manageUsers.rolesCell.none')}</span>;
  }
  const total = countUserRoleAssignments(user);
  return (
    <div className="manage-users-audit-cell">
      {t('manageUsers.rolesCell.count', { count: total })}
    </div>
  );
};
